<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        新增巡查点
      </div>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      :rules="rules"
      class="mt20"
    >
      <div class="f-right border-b">
        <div class="flex1">基本信息</div>
      </div>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-row>
            <el-form-item
              prop="patrol.c_point_area_id"
              label-width="160px"
              label="所属区域(部门)"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <!-- <el-input v-model="form.patrol.c_point_area"></el-input>
               -->

              <el-select v-model="form.patrol.c_point_area_id">
                <el-option
                  v-for="(item, index) in areaList"
                  :label="item.x_company_area"
                  :value="item.x_company_id"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label-width="160px"
              prop="patrol.c_point_number"
              label="巡查点编号"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <el-input v-model="form.patrol.c_point_number"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label-width="160px"
              prop="patrol.c_point_name"
              label="巡查点名称"
            >
              <el-input v-model="form.patrol.c_point_name"></el-input>
            </el-form-item>
            <el-form-item
              label-width="160px"
              prop="patrol.c_point_addr"
              label="巡查点位置"
            >
              <el-input v-model="form.patrol.c_point_addr"></el-input>
            </el-form-item>
            <el-form-item
              label-width="160px"
              prop="patrol.c_point_basic"
              label="巡查点设备"
            >
              <el-input v-model="form.patrol.c_point_basic"></el-input>
            </el-form-item>
            <el-form-item
              label-width="160px"
              prop="patrol.c_nfc"
              label="NFC编号"
            >
              <el-input v-model="form.patrol.c_nfc"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
      <div class="f-right border-b">
        <div class="flex1">巡检检查内容</div>
      </div>
      <div class="flex ml20">
        <el-col :span="11">
          <h3 class="ml20 mt10">巡查标准</h3>
          <div class="ml20 flex1 mt20" style="padding-left: 50px">
            <el-tree
              :data="list"
              ref="tree1"
              node-key="id"
              show-checkbox
              @check-change="handleCheckChange"
              class="tree"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-input
                  v-if="data.isEdit"
                  v-model="data.label"
                  size="mini"
                ></el-input>
                <span style="font-size:13px" v-else>{{ node.label }} </span>
                <span v-if="data.isSelf" class="mt20">
                  <el-button
                    class="mt20"
                    type="text"
                    v-if="node.id"
                    size="mini"
                    @click.native="() => changeNodeStatus(node, data, 1)"
                  >
                    编辑
                  </el-button>
                  <!-- 
             <el-button
          class="mt20"
            type="text"
            size="mini"
            v-if="node.level!==2"
            @click.native="() => saveAppend(node,data)">
            保存
          </el-button> -->
                  <el-button
                    type="text"
                    size="mini"
                    @click.native="() => changeNodeStatus(node, data, 0)"
                  >
                    删除
                  </el-button>
                </span>
              </span>
            </el-tree>
            <el-button type="primary" size="small" @click="addTree()"
              >添加自定义</el-button
            >
          </div>
        </el-col>
        <!-- <el-col class="ml20" :span="11">
          <h3 class="ml20 mt10">本次巡查点标准</h3>

          <el-tree
            :data="list2"
            show-checkbox
            ref="tree2"
            class="tree"

          >
          </el-tree>
        </el-col> -->
      </div>
    </el-form>

    <div class="btn-box">
      <div class="l-btn" @click="onSubmit">保存</div>
      <div class="l-btn ml20" @click="$router.back()">返回</div>
    </div>
    <el-dialog
      :visible.sync="showAddList"
      title="自定义巡查标准"
      width="40%"
      :show-close="false"
    >
      <div style="height:600px;overflow:auto">
        <el-button
          class="btn ml10"
          size="small"
          icon="icon-tr-newly-added"
          type="primary"
          @click="addTree(true)"
        >
          新增
        </el-button>
        <el-tree
          :data="addList"
          ref="tree2"
          node-key="id"
          :expand-on-click-node="false"
          class="tree mt10"
        >
          <span
            class="custom-tree-node"
            style="padding:20px"
            slot-scope="{ node, data }"
          >
            <el-input v-model="data.label" size="mini"></el-input>
            <span v-if="data.isSelf" class="mt20">
              <el-button
                class="mt20"
                type="text"
                v-if="node.level !== 2"
                size="mini"
                @click.native="() => append(node, data)"
              >
                增加
              </el-button>

              <el-button
                type="text"
                size="mini"
                @click.native="() => remove(node, data, addList)"
              >
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div>
        <el-button type="primary" @click="saveAppend">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";

export default {
  data() {
    return {
      value: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      id: this.$route.query.id || "",
      areaId: this.$route.query.areaId || "",
      cpNum: this.$route.query.cnum || "",
      expandedArr: [],
      expandAuto: true,
      showAddList: false,
      addList: [],
      form: {
        isTime: true,
        patrol: {
          c_point_number: "", //编号
          c_point_name: "", //名称
          c_point_area_id: "", //区域、
          c_point_area: "", //区域、
          c_point_id: "",
          c_point_addr: "", //地点
          c_nfc: "", //nfc编号
          c_point_basic: "",
          c_image_url: "", //二维码
          // roadNameDoorplate: "",
          // builderName: "",
        },
        // get_rate: [{ m_start_time: "", m_end_time: "", m_rate: "" }],
        get_item: [],
      },
      rules: {},
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],
      list: [],
      areaList: [],
    };
  },
  created() {
    if (this.areaId) {
      this.form.patrol.c_point_area_id = this.areaId;
    }
    if (this.cpNum) {
      this.getList();
    }
  },
  mounted() {},

  methods: {
    changeNodeStatus(node, data, state) {
      console.log(node);
      if (state) {
        // 编辑
        this.addList = [
          {
            label: node.data.label,
            uid: node.data.uid,
            isSelf: true,
            level: node.level,
            children: node.data.children,
            disabled: true,
          },
        ];
        if (!this.showAddList) {
          this.showAddList = true;
        }
        this.expandAuto = true;

        // if (data.isEdit) {
        //   // 保存
        //   this.$put("/checklist/checkListMainPoint/", data).then((res) => {
        //     this.$message({message: res.msg,type: "success", duration: 700,});
        //     data.isEdit = !data.isEdit;
        //   });
        //   console.log("保存");
        // } else {
        //   data.isEdit = !data.isEdit;
        // }
      } else {
        // 删除
        this.$remove("/checklist/checkListMainPoint/" + data.id).then((res) => {
          this.$message({ message: res.msg, type: "success", duration: 700 });
          this.remove(null, data, this.list);
        });
        console.log("shanchu");
      }
    },
    addTree(type) {
      if (this.addList.length < 1 || type == true)
        this.addList.push({
          label: "",
          uid: new Date().getTime(),
          isSelf: true,
          level: 1,
          children: [],
          disabled: true,
        });
      if (!this.showAddList) {
        this.showAddList = true;
      }
      this.expandAuto = true;
    },
    saveAppend(node, data) {
      let url = this.$store.state.user.userInfo.isWenwu
        ? "/inspection/wenwuInspectionPoint"
        : "/checklist/checkListMainPoint";
      var obj = {
        companyNum: this.$route.query.cnum,
        pointId: this.$route.query.areaId,
        checkListMainPoints: this.addList,
      };
      this.$post(url, obj)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({ message: res.msg, type: "success", duration: 700 });
            this.getList(1);
            this.expandAuto = true;
            this.showAddList = false;
            this.addList = [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    append(node, data) {
      if (data.level == 2) return;
      node.expanded = true;
      data.children.push({
        label: "",
        pId: data.uid,
        uid: new Date().getTime(),
        isSelf: true,
        level: 2,
        children: [],
        disabled: true,
      });
    },
    remove(node, data, list) {
      list = list ? list : this.addList;
      console.log(data);
      if (data.pId || data.uid) {
        // 还未调接口 自己
        if (data.pId) {
          // 删除的子项
          list.map((item) => {
            if (item.uid === data.pId) {
              item.children.map((it, ind) => {
                if (it.uid === data.uid) {
                  item.children.splice(ind, 1);
                }
              });
            }
          });
        } else {
          // 删除父项
          list.map((item, index) => {
            if (item.uid === data.uid) {
              list.splice(index, 1);
            }
          });
        }
      } else {
        console.log("保存过 调接口");
      }
    },
    save() {
      if (!this.form.get_item.length) {
        this.$message.warning("请至少选择一项检查项");
      } else {
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");

        if (reg.test(this.form.patrol.c_point_number)) {
          this.$message.error("巡查点编号不可以为中文！");
          return;
        }

        var url = this.id ? "/patrol/patrolupdate" : "/patrol/patroladd";
        this.$post(url, this.form).then((res) => {
          // this.$message.success("操作成功");
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 700,
          });
          this.$router.back();
        });
      }
    },

    onSubmit() {
      console.log(this.form);
      this.$refs.tree1.getHalfCheckedKeys();
      var arr = this.$refs.tree1
        .getCheckedKeys()
        .concat(this.$refs.tree1.getHalfCheckedKeys());
      console.log(arr);
      this.form.get_item = arr;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //this.save()
          this.save();
        } else {
          return false;
        }
      });

      //    this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     this.save();
      //   } else {
      //     this.nowIndex = 0;
      //     return false;
      //   }
      // });

      // this.$refs.form.validate((valid) => {
      //               if (valid) {
      //                 this.save()
      //               } else {
      //                   console.log('error submit!!');
      //                   this.$message.warning('请填写必填项')
      //                   return false;
      //               }
      //           });
    },
    handleCheckChange(v, b) {
      // console.log(v.id);
      // console.log(v)
      this.CheckedKeys = this.$refs.tree1.getCheckedKeys();
      this.$refs.tree1.getCheckedKeys();
    },
    addtime() {
      if (this.form.get_rate.length < 2) {
        this.form.get_rate.push({
          m_start_time: "",
          m_end_time: "",
          m_rate: "",
        });
      } else {
        this.form.get_rate.splice(1);
      }
    },
    getList(only) {
      this.loading = true;
      this.$post("/checklist/findtree2", {
        companyNum: this.$route.query.cnum,
        pointId: this.$route.query.areaId,
      })
        .then((res) => {
          var arr = [];

          res.data.list.map((item) => {
            var obj = {
              id: item.m_uuid,
              label: item.checklist,
              isSelf: item.isSelf,
              isEdit: false,
              uid: item.m_uuid,
            };
            if (item.childChecl) {
              item.childChecl.map((ite) => {
                var obj2 = {
                  id: ite.m_uuid,
                  label: ite.checklist,
                  isSelf: ite.isSelf,
                  isEdit: false,
                  pId: ite.h_uuid,
                  uid: ite.m_uuid,
                };
                obj.children
                  ? obj.children.push(obj2)
                  : (obj.children = [obj2]);
              });
            }
            arr.push(obj);
          });
          this.list = arr;
          console.log(this.list);
          if (only) {
            this.$refs.tree1.setCheckedKeys(this.CheckedKeys);
            return (this.loading = false);
          }
          // this.total = res.data.count
          // this.list = res.data.list
          // this.loading = false
          if (this.id) {
            this.$post(`/patrol/patroldetail/${this.id}`).then((res) => {
              this.form.patrol = res.list.patrol[0];
              this.form.get_rate = res.list.rate;
              this.form.get_item = res.list.item;
              var arr1 = [];
              var resArr = [];
              res.list.item.map((item) => {
                resArr.push(item.m_uuid);
              });
              this.list.map((it) => {
                if (resArr.indexOf(it.id) > -1) {
                  resArr.splice(resArr.indexOf(it.id), 1);
                }
              });
              this.$refs.tree1.setCheckedKeys(resArr);
            });
          }
        })
        .catch((err) => {});
      this.$post("/patrol/selectarea", { c_company_num: this.cpNum }).then(
        (res) => {
          this.areaList = res.data;
        }
      );
    },
    //树的数组
  },
};
</script>

<style scoped>
.container-list {
  padding: 0 20px;
}

.tree {
  font-size: 18px;
  margin-bottom: 20px;
}

::v-deep .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 32px;
  cursor: pointer;
}
</style>
